<template>
  <EquipmentRow
    :key="`${switchboard?.id}`"
    data-cy="switchboard-row-equipment-row"
  >
    <template #left></template>
    <template #default="{ toggle }">
      <AddRemoveButtons
        :hide-add-below="true"
        :disable-remove="!equipment.switchboard_id"
        data-cy="switchboard-row-add-remove-buttons"
        @remove="
          equipmentForm.update({
            r_switchboard: null,
            switchboard_id: null
          })
        "
      >
        <template #middle-content>
          <EquipmentPanel
            class="flex-grow-1"
            :rule-names="[
              'switchboard_volt_rating',
              'switchboard_amp_rating',
              'switchboard_obsolete'
            ]"
            :disableToggle="false"
            data-cy="switchboard-row-equipment-panel"
            @toggle="toggle"
          >
            <template #header>
              <span data-cy="switchboard-row-panel-header">Switchboard</span>
            </template>
            <template v-if="switchboard" #trigger>
              <span data-cy="switchboard-row-panel-trigger">
                {{ computeSwitchboardLabel(switchboard) }}
              </span>
            </template>
          </EquipmentPanel>
        </template>
      </AddRemoveButtons>
    </template>
    <template #expand="{ toggle }">
      <SwitchboardSearchView
        :is-admin="false"
        data-cy="switchboard-row-search-view"
        @select="handleSwitchboardSelect($event, toggle)"
      />
    </template>
    <template #right>
      <ConverterInput
        label="Input Line Voltage"
        :model-value="parameters.vsd_input_voltage"
        mode="write"
        :base-unit="VoltageUnits.Volts"
        :model="VoltageUnits.options()"
        data-cy="switchboard-row-converter-input"
        @update:model-value="
          parametersForm.update({
            vsd_input_voltage: $event
          })
        "
      />
    </template>
  </EquipmentRow>
</template>

<script setup lang="ts">
import { computed, provide } from "vue";
import EquipmentRow from "@/components/scenarios/EquipmentRow.vue";
import EquipmentPanel from "@/components/scenarios/EquipmentPanel.vue";
import SwitchboardSearchView from "./SwitchboardSearchView.vue";
import { computeSwitchboardLabel } from "@/models/equipment/switchboards/properties";
import { injectStrict } from "@/utils/utils";
import {
  equipmentFormKey,
  parametersFormKey
} from "@/composables/scenarioDetailProvider/scenarioDetailProviderKeys";
import ConverterInput from "@/components/ConverterInput.vue";
import { VoltageUnits } from "@/libs/units/voltage";
import AddRemoveButtons from "@/components/AddRemoveButtons.vue";
import type { Switchboards } from "gql/api";

const equipmentForm = injectStrict(equipmentFormKey);
const equipment = computed(() => equipmentForm.data.value);

const parametersForm = injectStrict(parametersFormKey);
const parameters = computed(() => parametersForm.data.value);

const switchboard = computed(() => equipment.value.r_switchboard);

provide(
  "selected-equipment-id",
  computed(() => switchboard.value?.id)
);

function handleSwitchboardSelect(
  switchboard: Switchboards,
  toggle: () => void
): void {
  toggle();
  equipmentForm.update({
    r_switchboard: switchboard,
    switchboard_id: switchboard?.id
  });
}
</script>
